import Sticky from "sticky-js"

const run = () => {
  const stickies = new Sticky("[data-sticky]")

  document.addEventListener("ad:showing", () => stickies.update())

  return { stickies }
}

export default run
